'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState, startTransition } from 'react'
import { Sun, Moon } from 'lucide-react'
import { analytics } from '@/lib/analytics'

interface ThemeToggleProps {
  iconOnly?: boolean
}

export default function ThemeToggle({ iconOnly = false }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Avoid hydration mismatch
  useEffect(() => {
    startTransition(() => {
      setMounted(true)
    })
  }, [])

  if (!mounted) {
    return (
      <button
        className="p-1.5 rounded-md transition-colors cursor-pointer"
        aria-label="Toggle theme"
      >
        <Sun className="w-4 h-4" />
      </button>
    )
  }

  const isDark = theme === 'dark'

  return (
    <button
      onClick={() => {
        const newTheme = isDark ? 'light' : 'dark'
        analytics.settings.themeChanged(newTheme)
        setTheme(newTheme)
      }}
      className={`p-1.5 rounded-md text-muted-foreground hover:text-primary hover:bg-muted transition-colors duration-150 touch-manipulation active:bg-muted/80 cursor-pointer ${iconOnly ? '' : 'flex items-center gap-2'}`}
      aria-label="Toggle theme"
    >
      {isDark ? (
        <Moon className="w-4 h-4 transition-colors" />
      ) : (
        <Sun className="w-4 h-4 transition-colors" />
      )}
      {!iconOnly && (
        <span className="text-sm">{isDark ? 'Dark' : 'Light'}</span>
      )}
    </button>
  )
}
